import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class TopicCard extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    prevTopic: PropTypes.object,
    handleTopicCardClicked: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      topic: {
        topicId:              null,
        topicName:             "",
        topicImageName:        "",
        topicImageAttribution: ""
      }
    };
  }

  componentDidMount() {
    this.setState({
      topic: this.props.topic,
      prevTopic: this.props.prevTopic
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const prevTopic = this.state.prevTopic;
    if (JSON.stringify(prevTopic) !== JSON.stringify(prevProps.prevTopic)) {
      this.setState({prevTopic: prevProps.prevTopic});
    }
  }

  render() {
    const {
      topic,
      prevTopic
    } = this.state;
    let topicImageUrl         = "";
    let topicImageAttribution = "";
    if (topic && topic.topicImageName && topic.topicImageAttribution) {
      topicImageUrl = "/images/landing_page/" + topic.topicImageName;
      topicImageAttribution = topic.topicImageAttribution;
    }

    return (
      <div className="topic-card" >
        {topic && topic.topicName && (
          <span>
            <button onClick={() => this.props.handleTopicCardClicked(topic,prevTopic)}>
            {topic.topicImageName && topic.topicImageName.length > 0 && (
              <img src={`${topicImageUrl}`}
                   alt={`${topic.topicName}`}
                   title={`${topicImageAttribution}`}
                   className={'topic-card-image'}
              />
            )}
              <div className={'topic-card-name'}>
                <p>{topic.topicName}</p>
              </div>
            </button>
          </span>
          )}
      </div>
    )
  }
}

export default TopicCard;



// WEBPACK FOOTER //
// ./src/features/landing-page/components/TopicCard.js